module.exports = __webpack_public_path__ + "static/media/logo_vertical_haut_bleu_texte_bleu.52e0bf02.png";